module.exports = __webpack_public_path__ + "static/media/034-Lonestar - Ottawa George St..981b035d.png";